<div [ngClass]="hideCardCss ? '' : 'apc-action-card light-gray accounts-action-card'">
    <div class="header mb-3">
        <div class="information" [class.pointer]="headerCursorPointer">
            <div *ngIf="showIcon" class="img-wrapper">
            <ng-content select="[icon]"></ng-content>
        </div>
            <div [ngClass]="{'uppercase': titleIsUpperCase, 'title-text': true, 'title-text-no-icon': !showIcon}">
                <ng-content select="[title]"></ng-content>
            </div>
        </div>

        <div class="action-buttons">
            <ng-content select="[buttons]"></ng-content>
        </div>
    </div>
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <ng-content select="[content]"></ng-content>
        </div>
    </div>
</div>